import {useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import Link from '@mui/material/Link';

import Loading from '../../common/Loading';

import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

import LoadListMapList from "./LoadListMapList";
import LoadListMapSpatial from "./LoadListMapSpatial";

export default function LoadListMap( props ) {
    const [open, setOpen] = useState(false);
    const [availableHeight, setAvailableHeight] = useState();
    
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };


    useEffect(() => {
        let viewportHeight = window.innerHeight;
        let elementTop = document.getElementById('contentBox').getBoundingClientRect().top;
        let availableHeightBelowElement = viewportHeight - elementTop;
        setAvailableHeight(availableHeightBelowElement);    
    },[props]);       


    const data = props.data.map((obj, idx) => {
        return { ...obj, childIdx: idx + 1 }
    })


    if(availableHeight == null){
        return(
            <Loading />
        );
    };


    return(
        <Box sx={{display:'flex', width:'100%', minHeight:availableHeight, backgroundColor:'silver'}}>
            <Box sx={{width:'30px', height:'100%', textAlign:'center'}}>
                <Link onClick={toggleDrawer(true)} sx={{textDecoration:'none', cursor:'pointer'}}>
                    <FormatListNumberedIcon fontSize='.5em' />
                    <Typography sx={{fontSize:'.5em', mt:-.5, pt:-.5}} >show</Typography>
                    <Typography sx={{fontSize:'.5em', mt:-.5, pt:-.5}} >List</Typography>
                </Link>                
                <Box>
                    <Drawer open={open} onClose={toggleDrawer(false)} >
                        <LoadListMapList data={data} user={props.user} openChildFx={props.openChildFx} />
                    </Drawer>
                </Box>
            </Box>
            <Grid container>
                <Grid item xs={12} sx={{height:'100%'}}>
                    <LoadListMapSpatial data={data} user={props.user} openChildFx={props.openChildFx} mapResize={availableHeight} showFilter={props.showFilter} />
                </Grid>
            </Grid>
        </Box>
    );
}
